import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    fileMessage: {
      padding: '16px',
      color: 'rgba(255, 255, 255, .60)',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
      left: '50%',
      position: 'absolute',
      transform: 'translateX(-50%)',
    },
    closeBtn: {
      padding: 5,
    },
    cardStyle: {
      padding: 8,
    },
    subCard: {
      padding: 16,
    },
    cursor: {
      cursor: 'pointer',
    },
    reportText: {
      color: 'rgba(255,255,255,0.87)',
      display: 'flex',
    },
    hipen: {
      margin: '0px 8px',
      color: 'rgba(255,255,255,0.87)',
    },
    reportSpan: {
      height: '5px',
      width: '5px',
      borderRadius: '50%',
      display: 'inline-block',
      backgroundColor: '#2AAB3F',
      margin: '16px 12px',
    },
    reportDate: {
      marginRight: 50,
      color: 'rgba(255,255,255,0.87)',
      verticalAlign: 'center',
    },
    card: { padding: 8 },
  }),
);

export default useStyles;
